"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("react-query");
const getDependenciesSma = (props) => {
    const { employeeId, baseUrl, emitClickMetric, emitErrorMetric, isSpoofing, } = props;
    return {
        baseUrl,
        employeeId,
        telemetry: undefined,
        authenticatedRequestHeaders: () => Promise.resolve({}),
        useQuery: react_query_1.useQuery,
        emitClickMetric,
        emitErrorMetric,
        emitDayOneWidgetError(errorMessage, metricName) {
            console.error(errorMessage, metricName);
        },
        isSpoofing: !!isSpoofing,
    };
};
exports.default = getDependenciesSma;
//# sourceMappingURL=getDependenciesSma.js.map